import { FC, useMemo } from 'react';

import { SearchTab } from './SearchTab';
import { DataTree, TestData } from '../types';
import { firstCategoryId } from '../constants/tests';


interface TabsSectionProps {
  data: DataTree[];
  testData: TestData[];
}

export const SearchResults: FC<TabsSectionProps> = (
  {
    testData,
    data
  }): JSX.Element => {
  const allTestsTabData = data.filter(data => data.allTests);
  
  
  let categoryId: string | any[] | null = null;
  let subCategoryId: string | any[] | null = null;
  
  useMemo(() => {
    if (window.location.toString().split('#')[1]) {
      categoryId = window.location.toString().split('#')[1];
      if (categoryId) {
        // setInitialCategoryId(categoryId);
      }
    }
    
    if (window.location.toString().split('#')[2]) {
      subCategoryId = window.location.toString().split('#')[2];
      if (subCategoryId) {
        // setInitialSubCategoryId(subCategoryId);
      }
    }
    
    setTimeout(() => {
      let categoryButton = document.getElementById(`cb-${categoryId}`);
      //
      if (!categoryId) {
        categoryButton = document.getElementById(`cb-${firstCategoryId}`);
      }
      //
      if (categoryButton) {
        categoryButton.click();
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    }, 1000);
    
  }, []);
  
  return (
    <div>
      <div className="pricing-tabs-content w-tab-content">
        <SearchTab
          initialSubCategoryId={subCategoryId}
          testData={testData}
          data={allTestsTabData}
        />
      </div>
    </div>
  );
};
